import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LoginService } from '../../modulos/login/login.service';
import { HelperService } from './helper.service';

export const adminRootGuard: CanActivateFn = () => {
  const router = inject(Router);
  const helper = inject(HelperService);
  const cliente = LoginService.getCliente();
  if (cliente?.nivel === 0) {
    return true;
  }
  helper.notifWarn('Sección sólo disponible para el cliente raíz');
  return router.parseUrl('/main');
};
